import { CommonModule } from '@angular/common';
import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { IconComponent } from '../../../../../shared/icons/icon.component';
import { AiHeadlinesComponent } from '../../../../../shared/components/ai-headlines/ai-headlines.component';

interface TrainingStat {
  status: string;
  count: number;
}

@Component({
  selector: 'app-monthly-report-2-mobile',
  standalone: true,
  imports: [CommonModule, IconComponent, AiHeadlinesComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './monthly-report-2-mobile.component.html',
})
export class MonthlyReport2MobileComponent {
  // ─── Inputs (provided by parent monthly-report-2 component) ─────────────
  startDate = input<string | null>(null);
  endDate = input<string | null>(null);
  mixedMode = input<boolean>(false);
  currentBusinessContractsOverall = input<any>(null);
  businessTrainingStatsData = input<TrainingStat[]>([]);

  // ─── Outputs ────────────────────────────────────────────────────────────
  filterRequested = output<void>();

  // ─── Local UI helpers (mirror parent component's color palette) ─────────
  private readonly iconBgColors = [
    'bg-[#2B7FFF]',
    'bg-[#AD46FF]',
    'bg-[#F6339A]',
    'bg-[#615FFF]',
    'bg-[#2B7FFF]',
    'bg-[#AD46FF]',
    'bg-[#F6339A]',
    'bg-[#615FFF]',
  ];

  openFilterSheet(): void {
    this.filterRequested.emit();
  }

  getBgColor(i: number): string {
    return this.iconBgColors[i % this.iconBgColors.length];
  }

  getTotalCount(): number {
    return this.businessTrainingStatsData().reduce(
      (acc, item) => acc + (item?.count ?? 0),
      0,
    );
  }
}
